import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { NotificationItemModel } from '../../models/notification-item.model';
import { environment } from '@env/environment';

// Substituir pela URL real quando o backend estiver pronto
const BASE_URL = environment.apiBaseUrl + '/notifications';

@Injectable({
  providedIn: 'root',
})
export class NotificationApiService {
  constructor(private readonly http: HttpClient) {}

  /**
   * Busca todas as notificações do usuário logado.
   * Conectar ao endpoint real — GET /notifications
   */
  getNotifications(): Observable<NotificationItemModel[]> {
    // return this.http.get<any>(BASE_URL).pipe(
    //   map((res) => res.data || [])
    // );
    return of([]);
  }

  /**
   * Marca uma notificação como lida.
   * TODO: Conectar ao endpoint real — PATCH /notifications/{id}/read
   */
  markAsRead(id: number): Observable<void> {
    // return this.http.patch<void>(`${BASE_URL}/${id}/read`, {});
    return of(undefined);
  }

  /**
   * Marca todas as notificações como lidas.
   * TODO: Conectar ao endpoint real — PATCH /notifications/read-all
   */
  markAllAsRead(): Observable<void> {
    // return this.http.patch<void>(`${BASE_URL}/read-all`, {});
    return of(undefined);
  }
}
